import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink
  ],
  templateUrl: './account.component.html',
  styleUrl: './account.component.css'
})
export class AccountComponent {
  constructor(
    public authService: AuthService,
    public router: Router
  ) {}

  signOut(): void {
    this.authService.signOut()
    .then(() => {
      this.router.navigate(['/']);
    })
    .catch((error) => {
      alert(error.message);
    });
  }

}
